module.exports = __webpack_public_path__ + "static/media/tape.94fd69e0.svg";